import { ModalBackground } from 'design-system-web';

/**
 * @deprecated  Use `ModalBackground` from `design-system-web` instead.
 */
export default ModalBackground;
